/*** IMPORTS FROM imports-loader ***/
var define = false;

import debounce from "./debounce";

let drawerSelector = '';

const StickyHomeDisciplinesFilter = {
  selector: '',
  init: function (selector) {
    drawerSelector = selector;
    this.stick();
      document.addEventListener('scroll', debounce(StickyHomeDisciplinesFilter.stick, 15));
  },
  stick: function () {
    const homeDisciplinesFilter = document.querySelector(drawerSelector);
    const header = document.querySelector('.home-header');
    const mobileStick = header.offsetTop + header.offsetHeight;
    const em = parseFloat(getComputedStyle(document.body).fontSize);

    const tabletStick = 32.5 * em - (.25 * window.innerHeight);
    const desktopStick = 42.5 * em - (.25 * window.innerHeight);

    const fixed = window.matchMedia('screen and (min-width: 720px)').matches
      ? window.matchMedia('screen and (min-width: 992px)').matches
        ? window.pageYOffset > desktopStick
        : window.pageYOffset > tabletStick
      : window.pageYOffset > mobileStick;

    if (fixed) {
      homeDisciplinesFilter.classList.add('fixed');
    } else {
      homeDisciplinesFilter.classList.remove('fixed');
    }
  },
}

export default StickyHomeDisciplinesFilter;

